import isOnDemand from "./isOnDemand"

const mapPrice = (options, isDaily = true, teamSize = 1) => {
  let price = 0
  let multiple = ""
  for (let i = 0; i < options.length; i++) {
    const option = options[i]
    const optionPrice = isOnDemand()
      ? isDaily
        ? option.price_per_day
        : option.price_per_hour
      : option.price * Number(teamSize)

    if (!price || price > optionPrice) {
      price = optionPrice
    }
    if (price && price < optionPrice) {
      multiple = "+"
    }
  }
  return `$${price.toLocaleString("en")}${multiple}`
}

export default mapPrice
